<script setup>
import { onMounted } from 'vue';
import Nav from './components/nav.vue';
import HeroSection from './components/HeroSection.vue';
import TrustBar from './components/TrustBar.vue';
import CourseSection from './components/CourseSection.vue';
import MasterSection from './components/MasterSection.vue';
import FitSection from './components/FitSection.vue';
import GallerySection from './components/GallerySection.vue';
import ClassSection from './components/ClassSection.vue';
import NotesSection from './components/NotesSection.vue';
import FeedbackSection from './components/FeedbackSection.vue';
import StepsSection from './components/StepsSection.vue';
import FaqSection from './components/FaqSection.vue';
import FinalCta from './components/FinalCta.vue';
import Footer from './components/Footer.vue';
import { logEvent } from '@/utils/firebase.js';

onMounted(() => {
  logEvent('mobile_fengsuids_uv');
  logEvent('mobile_fengsuids_pv');
});
</script>

<template>
  <div class="m-home">
    <Nav />
    <HeroSection />
    <TrustBar />
    <div id="course">
      <CourseSection />
    </div>
    <MasterSection />
    <FitSection />
    <GallerySection />
    <ClassSection />
    <NotesSection />
    <FeedbackSection />
    <StepsSection />
    <FaqSection />
    <FinalCta />
    <Footer />
  </div>
</template>

<style scoped lang="scss">
.m-home {
  width: 100%;
  font-family: 'Noto Sans TC', 'PingFang TC', 'Microsoft JhengHei', sans-serif;
  background: #f7f3ea;
  color: #2c2a25;
  line-height: 1.7;
}
</style>
